import React from "react";

import ReactDOM from "react-dom";
import { ButtonPrimary } from "../../StyledComponent";
import {
  PopupEditRepairContainer,
  FieldContainer,
  ButtonsContainer,
  HeaderContainer,
  InfosContainer,
} from "./styles";

import { PageTitle } from "../../../Pages/Sindico/styles";
import { PageOverlay } from "../../MessagePopup/style";
import AttachDocuments from "../NovaSolicitacao/AttachDocuments";
import CloseButton from "../../Reutilizaveis/CloseButton";

const EditSolicitacaoPopup = ({
  setReparos,
  saveFn,
  cancelFn,
  reparos,
  reparo,
  newDescription,
  setNewDescription,
  repairNumber,
  tema,
  isSindico,
}) => {
  console.log("reparo", reparo);
  function handleSalvar() {
    saveFn();
  }
  function handleCancelar() {
    cancelFn();
  }

  function handleChangeDescription(event) {
    setNewDescription(event.target.value);
  }

  return ReactDOM.createPortal(
    <PageOverlay>
      <PopupEditRepairContainer>
        <InfosContainer>
          <HeaderContainer>
            <div>
              <PageTitle>
                Edição de reparo {repairNumber?.toString()?.padStart(2, "0")}
              </PageTitle>
              <CloseButton tamanho={24} onClick={handleCancelar} />
            </div>
            <span className="subtitle">
              Corrija ou adicione algo que faltou no seu pedido:
            </span>
          </HeaderContainer>

          {/* 
          <RepairNumber>
            Reparo: {repairNumber?.toString()?.padStart(2, "0")}
          </RepairNumber> */}
          {console.log("reparo", reparo)}
          <FieldContainer>
            <label>Apontamento</label>
            <span>
              {reparo?.descricao || reparo?.Descricao || reparo?.apontamento}
            </span>
          </FieldContainer>
          <FieldContainer>
            <label>Descrição</label>
            <div
              className="novaSolicitacao__descricao__text"
              style={{ marginTop: 12, marginBottom: 6 }}
            >
              <textarea
                type="text"
                wrap="soft"
                maxLength="2000"
                placeholder="Para dar andamento na sua solicitação de forma assertiva, descreva da melhor forma os pontos principais da sua questão."
                onChange={handleChangeDescription}
                value={newDescription}
              />
            </div>
            <label className="novaSolicitacao__descricao__obrigatorio">
              Campo obrigatório - {2000 - newDescription?.length} / 2000
            </label>
          </FieldContainer>
          <FieldContainer>
            {reparos?.length === 0 && <label>Anexos</label>}

            <AttachDocuments
              reparos={reparos}
              documents={reparo}
              setDocuments={setReparos}
              readOnly={false}
              tema={tema}
              isSindico={isSindico}
            />
          </FieldContainer>

          <ButtonsContainer>
            <ButtonPrimary light fullWidth onClick={handleCancelar} tema={tema}>
              Cancelar
            </ButtonPrimary>
            <ButtonPrimary
              fullWidth
              tema={tema}
              onClick={handleSalvar}
              disabled={!newDescription}
            >
              Salvar
            </ButtonPrimary>
          </ButtonsContainer>
        </InfosContainer>
      </PopupEditRepairContainer>
    </PageOverlay>,
    document.getElementById("MessagePopup")
  );
};

export default EditSolicitacaoPopup;
